import React, { useEffect, useState } from "react";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import { useNavigate, useParams } from "react-router-dom";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import LoadingPage from "../../../Components/layouts/loading";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcBusinessman, FcRules } from "react-icons/fc";
import PerformanceCircular from "./performance.jsx";
import PointsCircular from "./points.jsx";

const ViewPerEmployeeEep = () => {
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [employeeEepData, setEmployeeEepData] = useState();
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/eep/getEepById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setEmployeeEepData(res.data);
        } else {
          Toast("error", "Error while getting employee EEP");
        }
        setLoading(false);
      })
      .catch((err) => CustomErrorResponse(err))
      .finally(() => setLoading(false));
  }, [id, refresh]);

  if (loading) {
    <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center d-flex">
              <div className="col d-flex justify-content-between align-items-center">
                <div>
                  <h2 className="page-title mb-1">
                    <FcBusinessman className="fs-2 me-1" /> Employee Efficiency
                    Program
                  </h2>
                  <h4 className="text-muted">
                    <p>
                      View Employment Efficiency Score of{" "}
                      {employeeEepData?.employeeName}
                    </p>
                  </h4>
                </div>
              </div>
            </div>
          </div>

          <div className="card my-4">
            <div className="card-body">
              <div className="row align-items-start">
                {/* LEFT COLUMN */}
                <div className="col-md-4 col-xs-12">
                  <div className="card mb-3 h-100">
                    <div className="card-header">
                      <h3 className="card-title">Employee Details</h3>
                    </div>

                    <div className="card-body p-0">
                      <table className="table table-sm mb-0">
                        <tbody>
                          <tr>
                            <td>Employee Id</td>
                            <td className="fw-bold text-end">
                              {employeeEepData?.employeeId}
                            </td>
                          </tr>
                          <tr>
                            <td>Employee Full Name</td>
                            <td className="fw-bold text-end">
                              {employeeEepData?.employeeName}
                            </td>
                          </tr>
                          <tr>
                            <td>Joining Date</td>
                            <td className="fw-bold text-end">
                              {employeeEepData?.joingDate}
                            </td>
                          </tr>
                          <tr>
                            <td>Role in organisation</td>
                            <td className="fw-bold text-end">
                              {employeeEepData?.employeeRole}
                            </td>
                          </tr>
                          <tr>
                            <td>Employment Status</td>
                            <td className="fw-bold text-end">
                              {employeeEepData?.employementStatus}
                            </td>
                          </tr>
                          {/* <tr>
                            <td>Current Pay</td>
                            <td className="fw-bold text-end">
                              {employeeEepData?.currentPayPerMonth}
                            </td>
                          </tr> */}
                          <tr>
                            <td>EEP Month</td>
                            <td className="fw-bold text-end">
                              {employeeEepData?.eepMonth}
                            </td>
                          </tr>
                          <tr>
                            <td>EEP Year</td>
                            <td className="fw-bold text-end">
                              {employeeEepData?.eepYear}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* EEP Calculations  */}

                  <div className="card mt-2">
                    <div
                      style={{
                        backgroundColor: "rgb(100, 149, 237, 0.12)",
                      }}
                    >
                      <div className="card-header">
                        <h3 className="card-title">
                          <FcRules className="fs-2 me-1" /> EEP Calculation
                          Policy
                        </h3>
                      </div>

                      <div
                        className="card-body"
                        style={{
                          maxHeight: "300px", // adjust height as needed
                          overflowY: "auto",
                        }}
                      >
                        {/* <h3>Scrum Score Calculation</h3>
                        <ul>
                          <li>
                            If employee is <strong>absent</strong> → Subtract 1
                            point from Scrum Score, add 1 point in Points Per
                            Month
                          </li>
                          <li>
                            If employee is <strong>present</strong> → Add 1
                            point in Scrum Score, add 1 point in Points Per
                            Month
                          </li>
                        </ul>

                        <h3>Task Score Calculation</h3>
                        <ul>
                          <li>
                            If task is <strong>completed</strong> → Add 1 point
                            in Task Score, add 1 point in Points Per Month
                          </li>
                          <li>
                            If task is <strong>pending</strong> → Subtract 1
                            point in Task Score, add 1 point in Points Per Month
                          </li>
                        </ul>

                        <h3>Test Score Calculation</h3>
                        <ul>
                          <li>
                            If test is <strong>attained</strong> → Add 1 point
                            in Test Score, add <strong>2 points</strong> in
                            Points Per Month
                          </li>
                        </ul>

                        <h3>Attendance Score Calculation</h3>
                        <ul>
                          <li>
                            Working hours more than <strong>9 hours</strong> →
                            +1 Attendance Score, +1 Points Per Month
                          </li>
                          <li>
                            Working hours <strong>4.5 to 9 hours</strong> → +0.5
                            Attendance Score, +1 Points Per Month
                          </li>
                          <li>
                            Login but forgot logout → -1 Attendance Score, +1
                            Points Per Month
                          </li>
                        </ul>

                        <h3>Leave Score Calculation</h3>
                        <ul>
                          <li>
                            Full day leave → +1 Leave Score, +1 Points Per Month
                          </li>
                          <li>
                            Half day leave → +0.5 Leave Score, +1 Points Per
                            Month
                          </li>
                          <li>
                            Multiple days leave → +1 Leave Score per day, +1
                            Points Per Month per day
                          </li>
                        </ul>

                        <p>
                          <strong>Example:</strong> 2 days approved leave →
                          Leave Score = 2 × 1 = 2
                        </p>

                        <h3>Not Approved Leave</h3>
                        <ul>
                          <li>
                            Full day → -1 Leave Score, +1 Points Per Month
                          </li>
                          <li>
                            Half day → -0.5 Leave Score, +1 Points Per Month
                          </li>
                          <li>
                            Multiple days → -1 Leave Score per day, +1 Points
                            Per Month per day
                          </li>
                        </ul>

                        <h3>Total Point Calculations</h3>
                        <p>
                          <strong>Total Points Gain (Monthly)</strong> = Scrum
                          Score + Task Score + Test Score + Attendance Score +
                          Leave Score
                        </p>

                        <p>
                          <strong>Total Points In Year</strong> = Previous Month
                          Total Points In Year + Points Per Month
                        </p>

                        <p>
                          <strong>Total Points Gain In Year</strong> = Previous
                          Month Total Gain In Year + Points Gain Per Month
                        </p> */}

                        <h3>Task Score Calculation</h3>
                        <ul>
                          <li>
                            The Work Output Score is calculated based on task
                            difficulty assigned to the employee.
                          </li>
                          <li>
                            If the task difficulty is{" "}
                            <strong>Micro, +1 point</strong> is added to the EEP
                            score.
                          </li>
                          <li>
                            If the task difficulty is{" "}
                            <strong>Small, +3 points</strong> are added to the
                            EEP score.
                          </li>
                          <li>
                            If the task difficulty is{" "}
                            <strong>Medium, +6 points</strong> are added to the
                            EEP score.
                          </li>
                          <li>
                            If the task difficulty is{" "}
                            <strong>Major, +12 points</strong> are added to the
                            EEP score.
                          </li>
                        </ul>

                        <h3>Discipline Score</h3>
                        <ul>
                          <li>
                            If an employee logs in late,{" "}
                            <strong>-1 point</strong> is deducted from the EEP
                            score.
                          </li>
                          <li>
                            If an employee misses the daily scrum,{" "}
                            <strong>-1 point</strong>is deducted.
                          </li>
                          <li>
                            If an employee does not update the daily scrum in
                            the system, <strong>-2 points</strong> are deducted.
                          </li>
                          <li>
                            If an employee forgets to log out,
                            <strong>-1 point</strong> is deducted.
                          </li>
                          <li>
                            If an employee takes leave without approval before
                            the leave date,<strong>-5 points</strong> are
                            deducted.
                          </li>
                          <li>
                            If an employee logs in late repeatedly (3 times in a
                            week), an <strong>additional -3 points</strong> are
                            deducted.
                          </li>
                        </ul>

                        <h3>Attendance Score</h3>
                        <ul>
                          <li>
                            If an employee logs in and logs out properly,
                            <strong>no points are added or deducted.</strong>
                          </li>
                          <li>
                            If an employee works less than
                            <strong>4.5 hours, -2 points</strong> are deducted.
                          </li>
                        </ul>

                        <h3>Learning and Training Score</h3>
                        <ul>
                          <li>
                            If an employee completes an internal training
                            program, <strong>+2 points</strong> are added.
                          </li>
                          <li>
                            If an employee passes a skill test,{" "}
                            <strong>+3 points</strong> are added.
                          </li>
                        </ul>

                        <h3>Penalty Score</h3>
                        <ul>
                          <li>
                            Penalties can be applied by the{" "}
                            <strong>Super Admin or Admin.</strong>
                          </li>
                          <li>
                            If an employee performs{" "}
                            <strong>fake task completion, -20 points</strong>{" "}
                            are deducted from the final EEP score.
                          </li>
                          <li>
                            If an employee engages in{" "}
                            <strong>false reporting, -20 points</strong> are
                            deducted from the final EEP score.
                          </li>
                          <li>
                            If an employee is involved in{" "}
                            <strong>data manipulation, -30 points</strong> are
                            deducted from the final EEP score.
                          </li>
                          <li>
                            If an employee deletes or hides{" "}
                            <strong>CRM data, -30 points</strong> are deducted
                            from the final EEP score.
                          </li>
                          <li>
                            Penalties are applied{" "}
                            <strong>for each instance of misconduct</strong> by
                            the employee.
                          </li>
                        </ul>

                        <h3>EEP Score Calculation Formula</h3>
                        <ul>
                          <strong>
                            EEP Score = 100 + Work Output Score + Discipline
                            Score + Attendance Score + Learning and Training
                            Score
                          </strong>
                        </ul>

                        <h3>Monthly Performance Band</h3>
                        <ul>
                          <li>
                            If the EEP score is{" "}
                            <strong>120 or above → Top Performer</strong>
                          </li>
                          <li>
                            If the EEP score is{" "}
                            <strong>110–119 → Strong Performer</strong>
                          </li>
                          <li>
                            If the EEP score is{" "}
                            <strong>95–109 → Normal Performer</strong>
                          </li>
                          <li>
                            If the EEP score is{" "}
                            <strong>80–94 → Needs Improvement</strong>
                          </li>
                          <li>
                            If the EEP score is{" "}
                            <strong>below 80 → At Risk Employee</strong>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div> 
                </div>

                {/* RIGHT COLUMN */}
                <div className="col-md-8 col-xs-12">
                  <div className="card h-100">
                    <div className="card-header">
                      <h3 className="card-title">
                        Employee Performance Summary
                      </h3>
                    </div>
                    <div className="card-body p-0">
                      <table className="table table-striped table-sm mb-0">
                        <tbody>
                          {/* <tr>
                            <td>Year Performance (%)</td>
                            <td className="fw-bold ">
                              {employeeEepData?.finalScorePerYearPercent || 0}%
                            </td>
                          </tr> */}

                          <tr>
                            <td>
                              {employeeEepData?.finalScorePerYearPercent &&
                              employeeEepData.finalScorePerYearPercent !== ""
                                ? `Year ${employeeEepData?.eepYear} Performance (%)`
                                : `Year ${employeeEepData?.eepYear} Performance`}
                            </td>

                            <td className="fw-bold">
                              {employeeEepData?.finalScorePerYearPercent &&
                              employeeEepData.finalScorePerYearPercent !== ""
                                ? `${employeeEepData.finalScorePerYearPercent}%`
                                : employeeEepData?.totalYearScoreFormulaScore &&
                                  employeeEepData.totalYearScoreFormulaScore !==
                                    ""
                                ? employeeEepData.totalYearScoreFormulaScore
                                : 0}
                            </td>
                          </tr>

                          <tr>
                            <td>
                              {employeeEepData?.finalScorePerMonthPercent &&
                              employeeEepData.finalScorePerMonthPercent !== ""
                                ? `${employeeEepData?.eepMonth} ${employeeEepData?.eepYear} Month Performance (%)`
                                : `${employeeEepData?.eepMonth} ${employeeEepData?.eepYear} Month Performance`}
                            </td>

                            <td className="fw-bold">
                              {employeeEepData?.finalScorePerMonthPercent &&
                              employeeEepData.finalScorePerMonthPercent !== ""
                                ? `${employeeEepData.finalScorePerMonthPercent}%`
                                : employeeEepData?.totalScoreFormulaScore &&
                                  employeeEepData.totalScoreFormulaScore !== ""
                                ? employeeEepData.totalScoreFormulaScore
                                : 0}
                            </td>
                          </tr>

                          <tr>
                            <td>
                              {employeeEepData?.scrumScore &&
                              employeeEepData.scrumScore !== ""
                                ? `Scrum Score`
                                : `Performance Band`}
                            </td>

                            <td className="fw-bold">
                              {employeeEepData?.scrumScore &&
                              employeeEepData.scrumScore !== ""
                                ? `${employeeEepData.scrumScore}%`
                                : employeeEepData?.monthlyPerformanceBand &&
                                  employeeEepData.monthlyPerformanceBand !== ""
                                ? employeeEepData.monthlyPerformanceBand
                                : 0}
                            </td>
                          </tr>

                          <tr>
                            <td>
                              {employeeEepData?.taskScore &&
                              employeeEepData.taskScore !== ""
                                ? `Task Score`
                                : `Work Output Score`}
                            </td>

                            <td className="fw-bold">
                              {employeeEepData?.taskScore &&
                              employeeEepData.taskScore !== ""
                                ? `${employeeEepData.taskScore}%`
                                : employeeEepData?.workOutputScore &&
                                  employeeEepData.workOutputScore !== ""
                                ? employeeEepData.workOutputScore
                                : 0}
                            </td>
                          </tr>

                          <tr>
                            <td>
                              {employeeEepData?.testScore &&
                              employeeEepData.testScore !== ""
                                ? `Test Score`
                                : `Attendance Score`}
                            </td>

                            <td className="fw-bold">
                              {employeeEepData?.testScore &&
                              employeeEepData.testScore !== ""
                                ? `${employeeEepData.testScore}%`
                                : employeeEepData?.attendanceScore &&
                                  employeeEepData.attendanceScore !== ""
                                ? employeeEepData.attendanceScore
                                : 0}
                            </td>
                          </tr>

                          <tr>
                            <td>
                              {employeeEepData?.attendenceScore &&
                              employeeEepData.attendenceScore !== ""
                                ? `Attendance Score`
                                : `Discipline Score`}
                            </td>

                            <td className="fw-bold">
                              {employeeEepData?.attendenceScore &&
                              employeeEepData.attendenceScore !== ""
                                ? `${employeeEepData.attendenceScore}%`
                                : employeeEepData?.disciplineScore &&
                                  employeeEepData.disciplineScore !== ""
                                ? employeeEepData.disciplineScore
                                : 0}
                            </td>
                          </tr>

                          <tr>
                            <td>
                              {employeeEepData?.leaveScore &&
                              employeeEepData.leaveScore !== ""
                                ? `Leave Score`
                                : `Learning Training Score`}
                            </td>

                            <td className="fw-bold">
                              {employeeEepData?.leaveScore &&
                              employeeEepData.leaveScore !== ""
                                ? `${employeeEepData.leaveScore}%`
                                : employeeEepData?.learningTrainingScore &&
                                  employeeEepData.learningTrainingScore !== ""
                                ? employeeEepData.learningTrainingScore
                                : 0}
                            </td>
                          </tr>

                          <tr>
                            <td>Penalty Score</td>
                            <td className="fw-bold ">
                              {employeeEepData?.fraudManipulationPenaltyScore ||
                                0}
                            </td>
                          </tr>

                          {employeeEepData?.pointPerMonth &&
                            employeeEepData.pointPerMonth !== "" && (
                              <tr>
                                <td>
                                  Total Points ({employeeEepData?.eepMonth})
                                </td>
                                <td className="fw-bold">
                                  {employeeEepData.pointPerMonth}
                                </td>
                              </tr>
                            )}

                          {employeeEepData?.finalScorePerMonth &&
                            employeeEepData.finalScorePerMonth !== "" && (
                              <tr>
                                <td>
                                  Total Points ({employeeEepData?.eepMonth})
                                </td>
                                <td className="fw-bold">
                                  {employeeEepData.finalScorePerMonth}
                                </td>
                              </tr>
                            )}

                          {employeeEepData?.pointPerYear &&
                            employeeEepData.pointPerYear !== "" && (
                              <tr>
                                <td>
                                  Total Points ({employeeEepData?.eepYear})
                                </td>
                                <td className="fw-bold">
                                  {employeeEepData.pointPerYear}
                                </td>
                              </tr>
                            )}

                          {employeeEepData?.finalScorePerYear &&
                            employeeEepData.finalScorePerYear !== "" && (
                              <tr>
                                <td>
                                  Total Points ({employeeEepData?.eepYear})
                                </td>
                                <td className="fw-bold">
                                  {employeeEepData.finalScorePerYear}
                                </td>
                              </tr>
                            )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card-footer text-end">
              <SimpleButton buttonText="Cancel" type="secondary" />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewPerEmployeeEep;
